import { useQuery } from '@tanstack/react-query';
import { getTenantNetworkStatus } from '../api/tenantNetwork/getTenantNetworkStatus';
import { getTenantNetworkStats } from '../api/tenantNetwork/getTenantNetworkStats';
import { getTenantNetworkListing } from '../api/tenantNetwork/getTenantNetworkListing';

export const useGetTenantNetworkStatus = (enabled = true) => {
  const { isLoading, isFetching, data, isError, refetch } = useQuery({
    queryKey: ['tenant-network-status'],
    queryFn: getTenantNetworkStatus,
    keepPreviousData: true,
    enabled,
    retry: 0,
    useErrorBoundary: false,
  });

  return {
    initializing: isLoading,
    isRefetching: isFetching && !isLoading,
    tenantNetworkStatus: data,
    isError,
    refetch,
  };
};

export const useGetTenantNetworkStats = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['tenant-network-stats'],
    queryFn: getTenantNetworkStats,
  });

  return {
    initializing: isLoading || isFetching || isError,
    tenantNetworkStats: data,
  };
};

export const useGetTenantNetworkListing = (propertyHubId: string | null, enabled?: boolean) => {
  const { isLoading, data, isError, refetch } = useQuery({
    queryKey: ['tenant-network-listing', propertyHubId],
    queryFn: () => getTenantNetworkListing(propertyHubId!),
    enabled: !!propertyHubId && enabled,
    retry: 0,
    keepPreviousData: true,
    useErrorBoundary: false,
  });

  return {
    initializing: isLoading,
    tenantNetworkListing: data,
    isError,
    refetch,
  };
};
